import { Badge, BadgeProps, HStack, Text } from '@chakra-ui/react'

import { Exclamation } from '../icon'

type Props = BadgeProps & {
  text: string
}

export const NotSetBadge: React.FC<Props> = ({ text, ...badgeProps }) => {
  return (
    <Badge
      height="18px"
      display="flex"
      alignItems="center"
      borderRadius="sm"
      bgColor="red.500"
      fontSize="10px"
      fontWeight="bold"
      px="4px"
      py="2px"
      {...badgeProps}
    >
      <HStack spacing="2px" align="center" color="white">
        <Exclamation size="10px" />
        <Text fontSize="10px" fontWeight="bold" as="span">
          {text}
        </Text>
      </HStack>
    </Badge>
  )
}
